import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=8f0ef2ca&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=8f0ef2ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f0ef2ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8f0ef2ca')) {
      api.createRecord('8f0ef2ca', component.options)
    } else {
      api.reload('8f0ef2ca', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=8f0ef2ca&scoped=true&", function () {
      api.rerender('8f0ef2ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2JVRjTY8s7QsL/JS/comp/PopupBox.vue"
export default component.exports